import React, { useState, useEffect } from "react";

const UserLocation = () => {
    const [location, setLocation] = useState({
        loaded: false,
        coordinates: { lat: "", long: "" },
    });

    const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0,
      };

    const onSuccess = (location) => {
        setLocation({
            loaded: true,
            coordinates: {
                lat: location.coords.latitude,
                long: location.coords.longitude,
            },
        });
    };

    const onError = (error) => {
        setLocation({
            loaded: true,
            error: {
                code: error.code,
                message: error.message,
            },
        });
    };
    useEffect(() => {
        if (!("geolocation" in navigator)) {
            onError({
                code: 0,
                message: "No Location located ",
            });
        }

        navigator.geolocation.getCurrentPosition(onSuccess, onError, options);
    }, []);

    return location;
};

export default UserLocation;